export const breadcrumbPathConstants = {
  PATH_SEPARATOR: "/",
  QUERY_SEPARATOR: "?",
  SPLAT: "*",
  SPACE: " ",
  HOME_LABEL: "Home",
  NO_BREADCRUMB_KEY: "NO_BREADCRUMB",
};

export const breadcrumbTypeConstants = {
  STRING: "string",
};

export const breadcrumbElementConstants = {
  SPAN: "span",
};

export const breadcrumbIndexConstants = {
  FIRST_CHAR: 0,
  FIRST_SEGMENT: 0,
  LAST_ITEM_OFFSET: 1,
  PARENT_META_OFFSET: 2,
  EQUAL_SCORE: 0,
  EMPTY_LENGTH: 0,
};

export const breadcrumbScoreConstants = {
  DYNAMIC_SEGMENT: 3,
  INDEX_ROUTE: 2,
  EMPTY_SEGMENT: 1,
  STATIC_SEGMENT: 10,
  SPLAT_PENALTY: -2,
};

export const breadcrumbErrorMessages = {
  PATH_OR_INDEX_REQUIRED:
    "useBreadcrumbs: `path` or `index` must be provided in every route object",
  PATH_AND_INDEX:
    "useBreadcrumbs: `path` and `index` cannot be provided at the same time",
  ABSOLUTE_CHILD_PATH:
    "useBreadcrumbs: The absolute path of the child route must start with the parent path",
  INDEX_HAS_CHILDREN:
    "useBreadcrumbs: Index route cannot have child routes",
};
